import {
    Chart as ChartJS,
    registerables
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(...registerables);

interface ChartProps {
    labels: Array<string>;
    datasets: Array<{
        label: string;
        data: Array<number>;
        backgroundColor: any,
        borderColor: string,
        borderWidth: number,
        tension: number,
        pointRadius: number,
        pointHoverRadius: number,
        [key: string]: any;
    }>,
    width?: string | number;
    height?: number;
    legendDisplay?: boolean;
}

function LineChart({ labels, datasets, width = 250, height = 120, legendDisplay = true }: ChartProps) {

    
    const data = {
        labels: labels,
        datasets: datasets
    };


    return (
        <Line
            data={data}
            width={width}
            height={height}
            options={{
                maintainAspectRatio: false,
                responsive: true,
                hover: {
                    mode: 'nearest',
                    intersect: false
                },
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    legend: {
                        display: legendDisplay,
                        align: "center",
                        position: "right"
                    },
                    tooltip: {
                        yAlign: 'bottom',
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        }
                    }
                }
            }}
        />
    )
}
export default LineChart